import React from 'react';
import { cn } from '../../utils/cn';
import { useThemeColors } from '../../providers/ThemeProvider';

interface TextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  error?: boolean;
  fullWidth?: boolean;
  resize?: 'none' | 'vertical' | 'horizontal' | 'both';
}

export const TextArea = React.forwardRef<HTMLTextAreaElement, TextAreaProps>(
  ({
    error = false,
    fullWidth = true,
    resize = 'vertical',
    className,
    disabled,
    ...props
  }, ref) => {
    const colors = useThemeColors();

    const resizeClasses = {
      none: 'resize-none',
      vertical: 'resize-y',
      horizontal: 'resize-x',
      both: 'resize',
    };

    return (
      <textarea
        ref={ref}
        disabled={disabled}
        className={cn(
          // Base styles
          'block px-3 py-2 border rounded-md shadow-sm',
          'text-sm',
          colors.classes.textPrimary,
          'placeholder-' + colors.values.textSecondary,
          colors.classes.bgPrimary,

          // State styles
          error ? [
            colors.classes.borderDanger,
            colors.classes.focusRingDanger,
          ] : [
            colors.classes.borderDefault,
            colors.classes.focusRingPrimary,
          ],

          // Disabled state
          disabled && cn(colors.classes.bgSecondary, 'cursor-not-allowed opacity-75'),

          // Resize behavior
          resizeClasses[resize],

          // Width
          fullWidth ? 'w-full' : 'w-auto',

          className
        )}
        {...props}
      />
    );
  }
);

TextArea.displayName = 'TextArea';